import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import des fichiers de traduction
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';

// Récupérer la langue sauvegardée ou utiliser l'espagnol par défaut
const savedLanguage = localStorage.getItem('language') || 'es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      fr: { translation: fr },
      en: { translation: en }
    },
    lng: savedLanguage,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false // React gère déjà l'échappement
    },
    react: {
      useSuspense: false
    }
  });

// Fonction utilitaire pour changer la langue
export const changeLanguage = (lang) => {
  localStorage.setItem('language', lang);
  i18n.changeLanguage(lang);
};

// Fonction utilitaire pour récupérer la langue actuelle
export const getCurrentLanguage = () => {
  return i18n.language || localStorage.getItem('language') || 'es';
};

export default i18n;
